import { render, staticRenderFns } from "./task-details.vue?vue&type=template&id=6dc7b1e6&scoped=true&"
import script from "./task-details.vue?vue&type=script&lang=js&"
export * from "./task-details.vue?vue&type=script&lang=js&"
import style0 from "./task-details.vue?vue&type=style&index=0&id=6dc7b1e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc7b1e6",
  null
  
)

export default component.exports